import script from "./term-condition.vue?vue&type=script&setup=true&lang=js"
export * from "./term-condition.vue?vue&type=script&setup=true&lang=js"

import "./term-condition.vue?vue&type=style&index=0&id=d2dbb916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2dbb916"]])

export default __exports__